package com.yendo.mx

import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.*
import androidx.compose.runtime.saveable.rememberSaveable
import com.yendo.mx.ui.auth.AuthScreen
import com.yendo.mx.ui.splash.SplashScreen
import com.yendo.mx.ui.HomeScreen
import com.yendo.mx.repository.AuthRepository
import com.yendo.mx.ui.theme.RosaYendo
import kotlinx.coroutines.launch
import androidx.compose.foundation.layout.*
import androidx.compose.ui.Modifier
import androidx.compose.animation.*
import androidx.compose.animation.core.tween
import androidx.compose.material3.*
import androidx.compose.ui.graphics.Color
import com.yendo.mx.ui.components.SinConexionScreen
import com.yendo.mx.utils.CargarFuentesEmojis
import com.yendo.mx.utils.ConfigurarCoilGlobal
import com.yendo.mx.utils.observarConexionInternet

// 🚀 AGREGAMOS SPLASH A LAS RUTAS
enum class AppRoute {
    SPLASH,
    AUTH,
    HOME
}

@Composable
fun App(idPedidoDeepLink: String? = null) {
    // 🚀 La ruta ahora sobrevive al Process Death. 
    // Al remover el bloqueo condicional de abajo, Compose recupera correctamente el estado de HomeScreen.
    var currentRoute by rememberSaveable { mutableStateOf(AppRoute.SPLASH) }
    var isGuestMode by rememberSaveable { mutableStateOf(false) }

    val scope = rememberCoroutineScope()

    // 🚀 OBSERVADOR GLOBAL DE INTERNET
    val estaConectado by observarConexionInternet().collectAsState()

    val isDark = androidx.compose.foundation.isSystemInDarkTheme()
    val colorFondo = if (isDark) Color(0xFF121212) else Color(0xFFF8F8F8)

    // 🚀 UNIFICAMOS EL ESQUEMA DE COLORES PARA EVITAR DESTELLOS
    val colorScheme = if (isDark) darkColorScheme(
        primary = RosaYendo,
        background = colorFondo,
        surface = Color(0xFF1E1E1E),
        onSurface = Color.White
    ) else lightColorScheme(
        primary = RosaYendo,
        background = colorFondo,
        surface = Color.White,
        onSurface = Color.Black
    )

    MaterialTheme(colorScheme = colorScheme) {
        ConfigurarCoilGlobal {
            CargarFuentesEmojis {
                Surface(modifier = Modifier.fillMaxSize(), color = colorFondo) {
                Box(modifier = Modifier.fillMaxSize()) {
                // 1. LA APP (Siempre vive debajo, manteniendo su estado)
            AnimatedContent(
                targetState = currentRoute,
                transitionSpec = {
                    fadeIn(animationSpec = tween(500)) togetherWith
                            fadeOut(animationSpec = tween(500))
                },
                label = "AppNavigation"
            ) { route ->
                when (route) {
                    AppRoute.SPLASH -> {
                        SplashScreen(
                            onNavigateToHome = {
                                isGuestMode = AuthRepository.usuarioActual.value?.esInvitado == true
                                currentRoute = AppRoute.HOME
                            },
                            onNavigateToAuth = {
                                currentRoute = AppRoute.AUTH
                            }
                        )
                    }
                    AppRoute.AUTH -> {
                        AuthScreen(
                            onLoginSuccess = {
                                isGuestMode = false
                                currentRoute = AppRoute.HOME
                            },
                            onGuestClick = {
                                scope.launch {
                                    AuthRepository.loginAnonimo()
                                    isGuestMode = true
                                    currentRoute = AppRoute.HOME
                                }
                            }
                        )
                    }
                    AppRoute.HOME -> {
                        HomeScreen(
                            esInvitado = isGuestMode,
                            idPedidoDeepLink = idPedidoDeepLink, // 🚀 PASAMOS EL LINK
                            onCerrarSesion = {
                                scope.launch {
                                    AuthRepository.cerrarSesion()
                                    currentRoute = AppRoute.AUTH
                                }
                            }
                        )
                    }
                }
            }

            // 2. CAPA DE BLOQUEO POR INTERNET (Solo aparece si no hay conexión)
            AnimatedVisibility(
                visible = !estaConectado,
                enter = fadeIn() + expandVertically(),
                exit = fadeOut() + shrinkVertically()
            ) {
                SinConexionScreen()
            }
        }
    }
    }
    }
}
}
